import React from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import logo from '../static/logo.jpg';
import './css/Header.css';
import './css/Search.css';
import useSelect from '../api/all_representatives';

const HookedSearch = withRouter(useSelect);

const HeaderPoint = ({ point, to, margin }) => (
  <Link style={margin} className="header_points_point" to={to}>
    {point}
  </Link>
);

const HeaderPoints = () => (
  <div className="header_points">
    <HeaderPoint margin={{ margin: '0 10px 0 0' }} point="she" to="/she/mainboard" />
    <HeaderPoint margin={{ margin: '0 10px' }} point="he" to="/he/mainboard" />
    <HeaderPoint margin={{ margin: '0 10px' }} point="artists" to="/artists/hair & makeup" />
    <HeaderPoint margin={{ margin: '0 10px' }} point="become a model" to="/become-a-model" />
    <HeaderPoint margin={{ margin: '0 10px' }} point="about" to="/about" />
    <HeaderPoint margin={{ margin: '0 10px' }} point="contact" to="/contact" />
    <HeaderPoint margin={{ margin: '0 10px' }} point="news" to="/news" />
    <HeaderPoint margin={{ margin: '0 10px' }} point="lightbox" to="/lightbox" />
  </div>
);

const HeaderLogoimg = () => (
  <>
    <Link to="/">
      <img className="header_logo" src={logo} alt="logo" />
    </Link>
  </>
);

export default () => (
  <div className="header">
    <div className="header_margin">
      <HeaderPoints />
      <HookedSearch />
      <HeaderLogoimg />
    </div>
  </div>
);
